import type {RouteWithSlug, SimpleRoute} from "../types";

/**
 * Tab identifiers for the trip detail page. The page itself is a single
 * route (`/trip/[id]`); tabs are switched client-side and reflected in
 * the `?tab=` query param for deep-linking.
 */
export const TRIP_TABS = {
    overview: "reservation",
    gettingThere: "getting-there",
    amenities: "amenities",
    terms: "rental-terms",
    pricing: "receipt",
    cancel: "cancel",
} as const;

export type TripTab = (typeof TRIP_TABS)[keyof typeof TRIP_TABS];

/**
 * Trip routes
 * - Find your trip: /trip
 * - Detail: /trip/[id] (optionally `?tab=` to deep-link a tab)
 */
export const tripRoute = {
    /**
     * Find your trip page: /trip
     */
    list: {
        path: "/trip",
        url: () => "/trip",
    } as SimpleRoute,

    /**
     * Trip detail page: /trip/[id]
     */
    detail: {
        path: "/trip/[id]",
        url: (id: string, tab?: TripTab) => `/trip/${id}${tab ? `?tab=${tab}` : ""}`,
    } as RouteWithSlug,
};
